// settings for mv slider
declare var Splide: any;

const mvSlider = () => {
  const sliderElement = document.querySelector('.js-splide');
  if (!sliderElement) return;
  const splide = new Splide(sliderElement, {
    type: 'fade',
    speed: 2000,
    pagination: false,
    autoplay: true,
    interval: 4500,
    pauseOnHover: false,
    rewind: true,
  });
  splide.mount();
};

export default mvSlider;
